// A phase's Dispatch action (Poulpe-581): a person's way, from the plan's
// page, to start a dispatcher on one phase. It opens the New session dialog
// filled with what such a session is told; the person picks the runner and
// the agent, and may edit the prompt. The session starts by the same
// start_session as any other, on no issue. Agents have start_session already;
// this action is for people.
//
// The session carries no structured plan or phase: the prompt names the plan
// by its id and the phase by its title, and tells the dispatcher to stop and
// ask if that phase is no longer there when it reads the plan.
import type { PhaseFacts } from './state'

/** Whether a phase has work to dispatch: neither exited nor parked, with an issue not yet landed. */
export function canDispatch(facts: Pick<PhaseFacts, 'state' | 'total' | 'landed'>): boolean {
  return facts.state !== 'exited' && facts.state !== 'parked' && facts.landed < facts.total
}

/** The session's title: within the dialog's 120 characters. */
export function dispatchTitle(phaseTitle: string): string {
  return `Dispatch ${phaseTitle}`.slice(0, 120)
}

/** What the dispatcher is first told: its plan by id, its phase by title, the guide, and what to do when the phase is gone. */
export function dispatchPrompt(plan: { id: string; title: string }, phaseTitle: string): string {
  return [
    `Dispatch the phase "${phaseTitle}" of the plan "${plan.title}" (plan id ${plan.id}).`,
    `Read Poulpe's get_guide dispatch and follow it for this phase alone: read the plan with get_plan, and hand each of this phase's open issues to a worker. Do not widen the work to another phase or to the whole plan.`,
    `If the plan has no phase titled "${phaseTitle}" when you read it, because it was renamed or removed, start nothing: ask me which phase to work, and wait for my answer.`,
  ].join('\n\n')
}
